'use strict';

import ContentBlock from './content-block';
import Collection from './collection';

export default class ContentBlockCollection extends Collection {
  constructor() {
    super(ContentBlock);
  }
}
